<template>
  <div>
    <v-divider
      color="accent"
      v-if="numRepuesto != 0 || numMaquina != 0"
    ></v-divider>
    <v-toolbar
      style="color: 'white'"
      class="subtitle-2 font-weight-bold text-uppercase"
      flat
      color="primary"
      dark
      dense
      v-if="numRepuesto != 0 || numMaquina != 0"
    >
      <v-row no-gutters>
        <v-col>
          <v-card class="d-flex flex-row" color="primary" flat>
            <v-card color="primary" class="pa-2" flat>
              <v-badge
               
                color="primary"
                :content="numMaquina"
                inline
                class="font-weight-medium body-2"
              >
                <v-chip
                  color="accent"
                  outlined
                  label
                  :disabled="numMaquina===0"
                  @click="itemrep('Maquina')"
                  style="cursor: pointer"
                  class="white--text font-weight-bold body-2 ma-n1"
                   @click:close="itemrep('Maquina')"
                  :close="checkRepuesto"
                  ><span>Maquina</span>
                </v-chip>
              </v-badge>
            </v-card>
            <v-card color="primary" class="pa-2" flat>
              <v-badge
               
                color="primary"
                :content="numRepuesto"
                inline
                class="font-weight-medium body-2"
              >
                <v-chip
                  color="accent"
                  style="cursor: pointer"
                  outlined
                  label
                   :disabled="numRepuesto===0"
                  :close="checkRepuesto"
                  @click="itemrep('Repuesto')"
                  class="white--text font-weight-bold body-2 ma-n1"
                @click:close="itemrep('Repuesto')"
                  ><span>Repuesto</span>
                </v-chip>
              </v-badge>
            </v-card>
          </v-card>
        </v-col>
      </v-row>
    </v-toolbar>
  </div>
</template>

<script>
import { mapState, mapActions, mapMutations, mapGetters } from "vuex";
export default {
  name: "ListaMaqRep",
  data() {
    return {
     tipoProd:''
    };
  },
  computed: {
    ...mapGetters(["filterconsolidado"]),
    ...mapState(["filter", "dataUser", "checkRepuesto"]),
    numRepuesto() {
      return this.filterconsolidado.filter((x) => x.TipoProd === "Repuesto")
        .length;
    },
    numMaquina() {
      return this.filterconsolidado.filter((x) => x.TipoProd === "Maquina")
        .length;
    },
  },
  methods: {
    ...mapMutations([
      "set_checkRepuesto",
     
      "GET_BUSCAREPUESTO", 
      "CLR_BUSCAREPUESTO"]),
    itemrep(p) {
      this.tipoProd = p;
      if (this.checkRepuesto === false) 
        this.GET_BUSCAREPUESTO(this.tipoProd);
      else this.CLR_BUSCAREPUESTO();
        this.set_checkRepuesto();
    },
  },
  watch: {
   
  },
};
</script>

<style>
</style>